exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".links-card {\n  margin-top: 20px;\n  padding: 20px; }\n  .links-card .links-card-content {\n    max-height: calc(100vh - 230px);\n    overflow: auto; }\n    .links-card .links-card-content .flex .delete {\n      -ms-flex-item-align: center;\n      align-self: center;\n      cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/products/edit/monitoring/Monitoring.scss
// module id = 1391
// module chunks = 0